import React from 'react';

/**
 * App-wide error boundary. Catches render-time exceptions anywhere in the tree
 * and shows a recoverable fallback instead of a blank white screen.
 *
 * Styles are inline and self-contained on purpose: if a stylesheet fails to load
 * the fallback must still render correctly.
 */
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    // Keep this visible in the console for now. When error tracking (e.g. Sentry)
    // is added, forward `error`/`errorInfo` here.
    console.error('Unhandled render error:', error, errorInfo);
  }

  handleReload = () => {
    window.location.assign('/');
  };

  render() {
    if (!this.state.hasError) {
      return this.props.children;
    }

    const wrap = {
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '24px',
      background: '#0f1115',
      color: '#e6e8eb',
      fontFamily: 'system-ui, -apple-system, Segoe UI, Roboto, sans-serif',
      textAlign: 'center',
    };
    const card = {
      maxWidth: '440px',
      background: '#171a21',
      border: '1px solid #262b36',
      borderRadius: '14px',
      padding: '32px 28px',
    };
    const btn = {
      marginTop: '20px',
      padding: '10px 22px',
      fontSize: '15px',
      fontWeight: 600,
      color: '#0f1115',
      background: '#4ade80',
      border: 'none',
      borderRadius: '8px',
      cursor: 'pointer',
    };

    return (
      <div style={wrap}>
        <div style={card}>
          <div style={{ fontSize: '40px', marginBottom: '8px' }}>⚠️</div>
          <h1 style={{ fontSize: '20px', margin: '0 0 8px' }}>Something went wrong</h1>
          <p style={{ fontSize: '14px', lineHeight: 1.5, color: '#9aa4b2', margin: 0 }}>
            The page hit an unexpected error. Reloading usually fixes it. If it keeps
            happening, please let us know.
          </p>
          <button style={btn} onClick={this.handleReload}>Reload app</button>
        </div>
      </div>
    );
  }
}

export default ErrorBoundary;
